import { useTranslation } from "react-i18next";
import { useAuthStore } from "../stores/authStore";

/**
 * Non-blocking banner while auth refresh waits for a cold backend to wake.
 */
export default function BackendWakingBanner() {
  const { t } = useTranslation();
  const isWakingUp = useAuthStore((state) => state.isWakingUp);

  if (!isWakingUp) {
    return null;
  }

  return (
    <div
      role="status"
      className="fixed inset-x-0 top-0 z-[100] flex items-center justify-center gap-2 border-b border-blue-200 bg-blue-50 px-4 py-2 text-sm text-blue-900 shadow-sm"
    >
      <span className="shrink-0 animate-spin text-blue-600" aria-hidden>⟳</span>
      <span>{t("auth.wakingUp")}</span>
    </div>
  );
}
